import { useState, MouseEvent, useEffect } from 'react';

// material-ui
import { Divider, List, ListItemButton, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';

// assets
import { Activity, Logout, Setting2, Buildings2, Crown } from 'iconsax-react';
import { Link } from 'react-router-dom';
import useAuth from 'hooks/useAuth';

import { FormattedMessage } from 'react-intl';
import { changeUserRole, switchOrganization } from 'services/user.service';
import { getSubOrganization } from 'services/organization.service';

import axios from 'axios';
import Snackbar from 'utils/Snackbar';
// ==============================|| HEADER PROFILE - PROFILE TAB ||============================== //

interface Props {
  handleLogout: () => void;
  setOpen?: () => void;
}

const ProfileTab = ({ handleLogout, setOpen }: Props) => {
  const { user,organization }: any = useAuth();
 
  const permission = user?.userTypeId?.permission;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [subOrgAnchorEl, setSubOrgAnchorEl] = useState<null | HTMLElement>(null);
  const [subOrganizations, setSubOrganizations] = useState<any[]>([]);
  const isParentOrg = !user?.organizationId?.parentOrganizationId; 
  const isNcvet = organization?.ncvetCompliance === true;
  const currentOrgId = user?.activeOrganizationId || user?.organizationId?._id;

  const handleListItemClick = (event: MouseEvent<HTMLDivElement>, index: number) => {
    setSelectedIndex(index);
    if (setOpen) {
      setOpen();
    }
  };

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setSelectedIndex(2);
  };

  const handleSelectRole = (role: string) => {
    changeUserRole({ type: role })
      .then((res) => {
        if (res.data?.data?.newToken) {
          localStorage.setItem('serviceToken', res.data?.data?.newToken);
          axios.defaults.headers.common.authToken = `${res.data?.data?.newToken}`;

          switch (role) {
            case 'admin':
              window.location.replace(`${window.location.protocol}//${window.location.host}/dashboard`);
              break;
            case 'student':
              window.location.replace(`${window.location.protocol}//${window.location.host}/learner`);
              break;
            case 'faculty':
              window.location.replace(`${window.location.protocol}//${window.location.host}/faculty`);
              break;
            default:
              window.location.replace(`${window.location.protocol}//${window.location.host}`);
          }
        }
      })
      .catch((err) => {
        Snackbar(err.response.data.message, 'error');
      });
    handleClose();
  };

  useEffect(() => {
    if (user?.type === 'faculty' || user?.type === 'student' || user?.type === 'learner' || user?.type === 'awardingBody' || user?.type === 'awarding-body') {
      return;
    }
    const parentOrgId = user?.activeOrganizationId || user?.organizationId?._id;

    if (!parentOrgId) return;

    getSubOrganization({ parentOrgId })
      .then((res) => {
        setSubOrganizations(res?.data?.data?.data || []);
      })
      .catch((err) => {
        Snackbar(err.response?.data?.message, 'error');
      });
  }, [user?.activeOrganizationId || user?.organizationId?._id]);
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSubOrgClick = (event: React.MouseEvent<HTMLElement>) => {
    setSubOrgAnchorEl(event.currentTarget);
  };

  const handleSubOrgClose = () => {
    setSubOrgAnchorEl(null);
  };

  const handleSwitchOrganization = (orgId: string) => {
    switchOrganization({ organizationId: orgId })
      .then((res) => {
        const newToken = res?.data?.data?.newToken;

        if (newToken) {
          localStorage.setItem('serviceToken', newToken);
          axios.defaults.headers.common.authToken = newToken;

          window.location.replace(`${window.location.protocol}//${window.location.host}/dashboard`);
        }
      })
      .catch((err) => {
        Snackbar(err.response?.data?.message || 'Organization switch failed', 'error');
      });

    handleSubOrgClose();
  };

  return (
    <List component="nav" sx={{ p: 0, '& .MuiListItemIcon-root': { minWidth: 32 } }}>
      {user?.type !== 'superadmin' && user?.type !== 'superAdmin' && user?.type !== 'support' && user?.type !== 'awarding-body' && user?.type !== 'awardingBody' && (
        <>
          {(user?.originalType || permission?.Users?.SwitchRole) && (
            <>
              <ListItemButton selected={selectedIndex === 2} onClick={handleClick}>
                <ListItemIcon>
                  <Activity variant="Bulk" size={18} />
                </ListItemIcon>
                <ListItemText primary={<FormattedMessage id="View As" />} />
              </ListItemButton>

              <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
                {[...(user?.originalType?.type === 'admin' || user?.type === 'admin' ? ['admin'] : []), 'faculty', 'student'].map(
                  (role) => (
                    <MenuItem
                      key={role}
                      onClick={() => handleSelectRole(role)}
                      selected={user?.type === role}
                      disabled={user?.type === role}
                    >
                      <FormattedMessage id={role} defaultMessage={role} />
                    </MenuItem>
                  )
                )}
              </Menu>
            </>
          )}

          {user?.type !== 'faculty' && user?.type !== 'student' && user?.type !== 'learner' && user?.type !== 'awarding-body' && isParentOrg && isNcvet &&(
            <>
              <ListItemButton onClick={handleSubOrgClick}>
                <ListItemIcon>
                  <Buildings2 variant="Bulk" size={18} />
                </ListItemIcon>
                <ListItemText primary={<FormattedMessage id="Training Centers" />} />
              </ListItemButton>

              <Menu anchorEl={subOrgAnchorEl} open={Boolean(subOrgAnchorEl)} onClose={handleSubOrgClose}>
                {subOrganizations?.filter((org) => org._id !== currentOrgId).length === 0 ? (
                  <MenuItem disabled>No Training Centers Found</MenuItem>
                ) : (
                  subOrganizations
                    ?.filter((org) => org._id !== currentOrgId)
                    .map((org) => (
                      <MenuItem key={org._id} onClick={() => handleSwitchOrganization(org._id)}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                          {org.isParent && <Crown size={14} color="#F9A825" />}
                          {org.name}
                        </div>
                      </MenuItem>
                    ))
                )}
              </Menu>
            </>
          )}

          {permission?.AccountSettings?.View && (
            <Link
              to={user?.type === 'student' ? '/learner/settings/accountSettings' : '/settings/accountSettings'}
              style={{ textDecoration: 'none' }}
            >
              <ListItemButton selected={selectedIndex === 8} onClick={(event: MouseEvent<HTMLDivElement>) => handleListItemClick(event, 4)}>
                <ListItemIcon>
                  <Setting2 variant="Bulk" size={18} />
                </ListItemIcon>
                <ListItemText primary={<FormattedMessage id="Settings" />} />
              </ListItemButton>
            </Link>
          )}
        </>
      )}

      <Divider />
      <ListItemButton selected={selectedIndex === 2} onClick={handleLogout}>
        <ListItemIcon>
          <Logout variant="Bulk" size={18} />
        </ListItemIcon>
        <ListItemText primary={<FormattedMessage id="Logout" />} />
      </ListItemButton>
    </List>
  );
};

export default ProfileTab;
